<template>
    <div class="template" v-if="newAllBetEvent.od[plytyp] && newAllBetEvent.od[plytyp][ouftsBetType]" :id="'test'+plytyp+'x'+ouftsBetType">
      <div data-template="template0" class="wrap-template template0"> <!-- class 'is_rang' allbet clash -->
        <div class="main-handicap">
          <div class="vrow items-center template-title is_fold">
            <div class="play-name col" @click="showLeg()">
              <span class="ellipsis">{{ getTitleCaption() }}</span>
            </div>
            <div style="width: 37px;" @click="setToTop($event)">
              <span class="set_top" style="display: none;">
                <i aria-hidden="true" role="presentation" class="q-icon icon-set_top c-icon"></i>
              </span>
            </div>
          </div>
          <template v-if="show">
            <template v-for="(subMatch, subMatchKey) in (Object.keys(newAllBetEvent.od[plytyp][ouftsBetType]).length)">
              <template
                v-if="newAllBetEvent.od[plytyp][ouftsBetType][Object.keys(newAllBetEvent.od[plytyp][ouftsBetType])[subMatchKey]]">
                <div class="handicap">
                    <div class="handicap-item m-oe os-1">
                        <div class="c-bet-item yb-flex-center relative-position zhuanye csid1 normal">
                            <div class="bet-inner yb-flex-center fit">
                                <div class="handicap-wrap">
                                    <div class="bet-item">
                                        <!---->
                                        <div class="item-label bet-ellipsis ellipsis" style="width: 85%;">
                                            <span class="ellipsis-wrap">{{ sportAllBetLang['ALL_BET.LBL_OVER'] }}
                                                <span class="bet_handicap yb-family-odds normal_color"> <span class="color">
                                                    <over-under :event="newAllBetEvent" :plyType="plytyp" :betType="ouftsBetType" :match="subMatchKey" />
                                                </span> </span>
                                                {{ sportAllBetLang['ALL_BET.AND'] }} {{ allBetEvent.tacapt }}
                                            </span>
                                        </div>
                                    </div>
                                </div>
                                <odd :event="newAllBetEvent" :team="'oddsha'" :plyType="plytyp" :betType="ouftsBetType" 
                                        :match="subMatchKey" :ref="'teamha' + subMatchKey" :mode="'ab'" />
                            </div>
                        </div>
                    </div>
                    <div class="handicap-item m-oe os-1">
                        <div class="c-bet-item yb-flex-center relative-position zhuanye csid1 normal">
                            <div class="bet-inner yb-flex-center fit">
                                <div class="handicap-wrap">
                                    <div class="bet-item">
                                        <!---->
                                        <div class="item-label bet-ellipsis ellipsis" style="width: 85%;">
                                            <span class="ellipsis-wrap">{{ sportAllBetLang['ALL_BET.LBL_OVER'] }}
                                                <span class="bet_handicap yb-family-odds normal_color"> <span class="color">
                                                    <over-under :event="newAllBetEvent" :plyType="plytyp" :betType="ouftsBetType" :match="subMatchKey" />
                                                </span> </span>
                                                {{ sportAllBetLang['ALL_BET.AND'] }} {{ allBetEvent.tbcapt }}
                                            </span>
                                        </div>
                                    </div>
                                </div>
                                <odd :event="newAllBetEvent" :team="'oddshb'" :plyType="plytyp" :betType="ouftsBetType" 
                                        :match="subMatchKey" :ref="'teamhb' + subMatchKey" :mode="'ab'" />
                            </div>
                        </div>
                    </div>
                    <div class="handicap-item m-oe os-1 no_border_bottom">
                        <div class="c-bet-item yb-flex-center relative-position zhuanye csid1 normal">
                            <div class="bet-inner yb-flex-center fit">
                                <div class="handicap-wrap">
                                    <div class="bet-item">
                                        <!---->
                                        <div class="item-label bet-ellipsis ellipsis" style="width: 85%;">
                                            <span class="ellipsis-wrap">{{ sportAllBetLang['ALL_BET.LBL_UNDER'] }}
                                                <span class="bet_handicap yb-family-odds normal_color"> <span class="color">
                                                    <over-under :event="newAllBetEvent" :plyType="plytyp" :betType="ouftsBetType" :match="subMatchKey" />
                                                </span> </span>
                                                {{ sportAllBetLang['ALL_BET.AND'] }} {{ allBetEvent.tacapt }}
                                            </span>
                                        </div>
                                    </div>
                                </div>
                                <odd :event="newAllBetEvent" :team="'oddsaa'" :plyType="plytyp" :betType="ouftsBetType" 
                                            :match="subMatchKey" :ref="'teamaa' + subMatchKey" :mode="'ab'" />
                            </div>
                        </div>
                    </div>
                    <div class="handicap-item m-oe os-1 no_border_bottom">
                        <div class="c-bet-item yb-flex-center relative-position zhuanye csid1 normal">
                            <div class="bet-inner yb-flex-center fit">
                                <div class="handicap-wrap">
                                    <div class="bet-item">
                                        <!---->
                                        <div class="item-label bet-ellipsis ellipsis" style="width: 85%;">
                                            <span class="ellipsis-wrap">{{ sportAllBetLang['ALL_BET.LBL_UNDER'] }}
                                                <span class="bet_handicap yb-family-odds normal_color"> <span class="color">
                                                    <over-under :event="newAllBetEvent" :plyType="plytyp" :betType="ouftsBetType" :match="subMatchKey" />
                                                </span></span>
                                                {{ sportAllBetLang['ALL_BET.AND'] }} {{ allBetEvent.tbcapt }}
                                            </span>
                                        </div>
                                    </div>
                                </div>
                                <odd :event="newAllBetEvent" :team="'oddsab'" :plyType="plytyp" :betType="ouftsBetType" 
                                        :match="subMatchKey" :ref="'teamab' + subMatchKey" :mode="'ab'" />
                            </div>
                        </div>
                    </div>
                  <div class="" style="padding: 0.5px; width: 100%;border: 1px solid var(--qq--yb-border-color15);" v-if="subMatchKey != (Object.keys(newAllBetEvent.od[plytyp][ouftsBetType]).length -1)"></div>
                </div>
              </template>
            </template> <!-- END submatch -->
          </template>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  import {
    mapGetters
  } from 'vuex'
  import OddComponents from '../../../components/odd'
  import HandicapComponents from '../../../components/handicap'
  
  import allBetMixin from '../../../mixins/allBet'
  
  export default {
    mixins: [allBetMixin],
    props: {
      allBetEvent: null,
      plytyp: null,
      selectMarket: null,
      removeMarket: null,
      rbinfo: null,
      myMarket: {
        type: Boolean,
        default: false
      },
      isSpecial: {
        type: Boolean,
        default: false
      },
      mode:null
    },
    data() {
      return {
        show: true,
      }
    },
    computed: {
      ...mapGetters([
        'foldopenAllBet',
        'foldopenFirstEvent'
      ]),
      newAllBetEvent() {
        // return _.cloneDeep(this.$store.getters.sortedMatchEventList)
        return this.allBetEvent
      },
    },
    watch: {
      foldopenAllBet() {
        if(this.mode=='ab'){
          this.show = (this.$store.getters.foldopenAllBet) ? true : false;
        }
      },
      foldopenFirstEvent() {
        if(this.mode!='ab'){
          this.show = (this.$store.getters.foldopenFirstEvent) ? true : false;
        }
      }
    },
    methods: {
      getTitleCaption() {
        var a = 'FT'
        var b = ''
        if (this.plytyp == this.firstHtPlyType) {
          a = '1H'
        }
  
        // if (this.bettype == this.hdpBetType) {
        b = this.sportAllBetLang['ALL_BET.SUBHEADER_OU_FTS']
        // } else if (this.bettype == this.bttsBetType) {
        //   b = this.sportAllBetLang['ALL_BET.SUBHEADER_' + a + '_BTTS']
        // }
  
        // RB score
        // if (this.newAllBetEvent.event_rb == 1) {
        //   b += ' (' + this.newAllBetEvent.rbinfo.scoa + '-' + this.newAllBetEvent.rbinfo.scob + ')'
        // }
        return b
      },
      showLeg() {
        this.show = (!this.show) ? true : false;
      },
      setToTop(e) {
        this.$parent.setToTop(e);
      },
      addToMyMarket(plytyp, csBetType) {
        if (this.selectMarket)
          this.selectMarket(this.allBetEvent, plytyp, csBetType, this.isSpecial)
      },
      removeFromMyMarket(plytyp, csBetType) {
        if (this.removeMarket)
          this.removeMarket(this.allBetEvent, plytyp, csBetType, this.isSpecial)
      },
    },
    mounted(){
      if(this.mode=='ab'){
        this.show = (this.$store.getters.foldopenAllBet) ? true : false;
      }else{
        this.show = (this.$store.getters.foldopenFirstEvent) ? true : false;
      }
    },
  }
  </script>
  


// WEBPACK FOOTER //
// resources/wob/vue/apps/sport/allBet/all-bet-oufts.vue